<template>
    <div class="p-5">

        <div class="m-5">

            <div class="flex-auto flex space-x-4">
                <router-link :to="{ name: 'home' }" class="py-2 px-6 rounded-md bg-black text-white">
                    Tools Home
                </router-link>
            </div>

        </div>

        <h1 class="text-5xl text-slate-600 font-bold tracking-tight">Tailwind Button Explorer</h1>

        <button-style-explorer></button-style-explorer>

    </div>
</template>

<script>

import ColorUtil from "../../app/utils/ColorUtil";
import StringUtil from "../../app/utils/StringUtil";
import BackgroundClassUtil from "../utils/BackgroundClassUtil";
import ButtonStyleExplorer from "../components/ButtonStyleExplorer.vue";

export default {
    name: 'ButtonExplorer',
    components: {ButtonStyleExplorer},
    computed: {
        buttonClasses() {
            let classes = ['mx-1', 'px-10', 'py-2', this.borderRadius, this.fontWeight]
            return classes
        }
    },
    data() {
        return {
            model: webase.model,
            colorNames: new ColorUtil().tailwindBrightColors(),
            neutralColorNames: new ColorUtil().tailwindNeutralColors(),
            colors: new ColorUtil().tailwindColors(),
            bgClassUtil: new BackgroundClassUtil(),
            borderRadius: 'rounded-lg',
            fontWeight: 'font-medium',
            gradientDirection: 'bg-gradient-to-r',
            selectedBorderOption: 'lg',
            borderOptions: Object.keys({
                "none": "0px",
                "sm": "0.125rem",
                "DEFAULT": "0.25rem",
                "md": "0.375rem",
                "lg": "0.5rem",
                "xl": "0.75rem",
                "2xl": "1rem",
                "3xl": "1.5rem",
                "full": "9999px"
            }),
            selectedFontWeightOptions: 'normal',
            fontWeightOptions: Object.keys({
                "thin": "100",
                "extralight": "200",
                "light": "300",
                "normal": "400",
                "medium": "500",
                "semibold": "600",
                "bold": "700",
                "extrabold": "800",
                "black": "900"
            }),
            selectedGradientOption: 'gradient-to-r',
            gradientOptions: Object.keys({
                "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
                "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
                "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
                "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
                "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
                "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
                "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
                "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
            })
        }
    },
    mounted() {
        console.log(new ColorUtil().tailwindBrightColors())
    },
    methods: {
        colorLabel(colorName) {
            return new StringUtil().titleCase(colorName)
        },
        lightClasses(colorName) {
            return `${this.bgClassUtil.lightClasses(colorName)} ${this.borderRadius} ${this.fontWeight}`
        },
        brightClasses(colorName) {
            return `${this.bgClassUtil.brightClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        darkClasses(colorName) {
            return `${this.bgClassUtil.darkClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        neutralDarkClasses(colorName) {
            return `${this.bgClassUtil.neutralDarkClasses(colorName)}  ${this.borderRadius} ${this.fontWeight}`
        },
        gradientClasses(colorName) {
            return `${this.gradientDirection} ${this.bgClassUtil.gradientClasses(colorName)} ${this.borderRadius} ${this.fontWeight}`
        },
        twoColorGradientClasses(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.twoColorGradientClasses(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        threeColorGradientClasses(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.threeColorGradientClasses(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        threeColorGradientClasses2(colorName, index) {
            return `${this.gradientDirection} ${this.bgClassUtil.threeColorGradientClasses2(colorName, index)} ${this.borderRadius} ${this.fontWeight}`
        },
        onBorderSelected() {
            this.borderRadius = this.selectedBorderOption === 'DEFAULT' ? 'rounded' : `rounded-${this.selectedBorderOption}`
        },
        onFontWeightSelected() {
            this.fontWeight = `font-${this.selectedFontWeightOptions}`
        },
        onGradientSelected() {
            this.gradientDirection = `bg-${this.selectedGradientOption}`
        },
        plus2(index) {
            return (index + 2) % this.colorNames.length
        },
        plus4(index) {
            return (index + 5) % this.colorNames.length
        },
        nextIndex(index) {
            return (index + 1) % this.colorNames.length
        },
        nextIndex2(index) {
            return this.plus2(index)
        }
    }
}
</script>
